<template>
    <loading-indicator v-if="loading" text="Optionen werden abgerufen."/>
    <div v-else>
        Der Abteilung {{assignedTaskCount === 1 ? 'ist noch eine Aufgabe' : 'sind noch ' + assignedTaskCount + ' Aufgaben'}} zugewiesen.
        Um fortzufahren, wählen Sie bitte <u>einen Mitarbeiter oder eine andere Abteilung</u> aus, der anschließend
        <u>alle Aufgaben</u> der zu löschenden Abteilung automatisch zugewiesen werden.<br><br>

        <div class="spacer-15">
            <form-row label="Alternativen Mitarbeiter auswählen" :class="{disabled: assignTaskData.entity_id}">
                <form-select-employee v-model="assignTaskData.owner" :options="assignTaskOptions.owners" @input="changeOwnerAssignment"/>
            </form-row>

            <form-row v-if="entityOptions.length" label="Alternative Abteilung auswählen" :class="{disabled: assignTaskData.owner}">
                <form-select v-model="assignTaskData.entity_id" :options="entityOptions" @input="changeEntityAssignment"/>
            </form-row>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator';
    import FormRow from '../../../components/form/FormRow.vue';
    import FormSelect from '../../../components/form/FormSelect.vue';
    import FormSelectEmployee from '../../../components/form/FormSelectEmployee.vue';
    import LoadingIndicator from '../../../components/LoadingIndicator.vue';
    import TopMessageHandler from '../../../library/topMessageHandler';
    import {errorHandler, XHR_STATUS_DEFAULT} from '../../../utils/portuna';

    @Component({
        name: 'EntityAssignTasks',
        components: {
            FormSelectEmployee,
            FormSelect,
            FormRow,
            LoadingIndicator,
        },
        methods: {},
    })
    export default class EntityAssignTasks extends Vue
    {
        @Prop({
            type: Number,
            default: 0,
            required: false,
        }) excludeEntityId: number;

        @Prop({
            type: Object,
            required: true,
        }) modelValue: { owner: number, entity_id: number };

        @Prop({
            type: Number,
            required: true,
        }) assignedTaskCount: number;

        assignTaskData: { owner: number, entity_id: number } = {owner: 0, entity_id: 0};

        loading = true;

        assignTaskOptions = {} as { employees: SelectOption[], entities: SelectOption[] };

        get entityOptions(): SelectOption[]
        {
            return this.assignTaskOptions.entities.filter(({value}) => value !== this.excludeEntityId);
        }

        @Watch('modelValue', {deep: true})
        watchValue()
        {
            this.assignTaskData = this.modelValue;
        }

        @Watch('assignTaskData', {deep: true})
        watchAssignTaskData()
        {
            this.modelValue = this.assignTaskData;
        }

        created()
        {
            this.assignTaskData = this.modelValue;

            this.fetchTaskAssignOptions();
        }

        fetchTaskAssignOptions()
        {
            this.loading = true;

            this.axios.get('/task/entry/fetch-assign-options')
            .then(response =>
            {
                if (response.data.status !== XHR_STATUS_DEFAULT)
                {
                    throw response;
                }

                this.assignTaskOptions = response.data.data;
            })
            .catch(errorHandler)
            .finally(() =>
            {
                this.loading = false;
            });
        }

        changeOwnerAssignment(newEmployee: number)
        {
            if (newEmployee)
            {
                this.assignTaskData.entity_id && TopMessageHandler.info('Die zugewiesene Abteilung wurde entfernt.');
                this.assignTaskData['entity_id'] = 0;
            }
        }

        changeEntityAssignment(newEntity: number)
        {
            if (newEntity)
            {
                this.assignTaskData.owner && TopMessageHandler.info('Der zugewiesene Mitarbeiter wurde entfernt.');
                this.assignTaskData['owner'] = 0;
            }
        }
    };
</script>